var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1421344023328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6397 14.9029C22.0371 21.3315 15.5259 25.2438 9.0965 23.6407C2.6698 22.038 -1.24254 15.5265 0.360847 9.09837C1.96283 2.66903 8.47399 -1.24361 14.9014 0.359081C21.3303 1.96177 25.2424 8.47404 23.6396 14.903L23.6397 14.9029H23.6397Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.2915 10.2903C17.5304 8.6934 16.3146 7.83498 14.6521 7.26233L15.1914 5.09914L13.8746 4.77103L13.3496 6.87726C13.0034 6.79092 12.6479 6.70957 12.2945 6.62892L12.8234 4.50878L11.5074 4.18066L10.9678 6.34315C10.6813 6.27793 10.3999 6.21347 10.127 6.14554L10.1285 6.13874L8.31258 5.68528L7.96229 7.09171C7.96229 7.09171 8.93925 7.31565 8.91866 7.32943C9.45189 7.46252 9.54832 7.81551 9.53231 8.09529L8.91796 10.5597C8.95467 10.569 9.0023 10.5825 9.05486 10.6036C9.01092 10.5927 8.96418 10.5808 8.91567 10.5692L8.05455 14.0214C7.98939 14.1834 7.82398 14.4266 7.45117 14.3342C7.46437 14.3534 6.4941 14.0954 6.4941 14.0954L5.84033 15.6027L7.55394 16.0299C7.87272 16.1098 8.18512 16.1935 8.49277 16.2721L7.94786 18.4601L9.26314 18.7883L9.80276 16.6235C10.1621 16.721 10.5108 16.811 10.8522 16.8958L10.3144 19.0504L11.6312 19.3785L12.1761 17.1946C14.4215 17.6196 16.1099 17.4482 16.8205 15.4172C17.3932 13.7821 16.792 12.8389 15.6107 12.2238C16.4711 12.0254 17.1192 11.4595 17.292 10.2905L17.2916 10.2902L17.2915 10.2903ZM14.2829 14.5091C13.876 16.1443 11.1229 15.2604 10.2302 15.0387L10.9533 12.14C11.8459 12.3628 14.7083 12.8038 14.283 14.5091H14.2829ZM14.6902 10.2666C14.319 11.754 12.0275 10.9984 11.2842 10.8131L11.9397 8.1841C12.6831 8.36939 15.0769 8.71522 14.6903 10.2666H14.6902Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.90ba1ac643fb26b7a8205cbd17225c1a.svg";
export { ForwardRef as ReactComponent };